import { expandMultiattack, hasStructuredMultiattack } from './multiattack';

export const createEnemyAttackTargeting = (enemy, action) => {
  const sourceCombatantId = enemy?.enemyId || enemy?._id;
  if (!sourceCombatantId || !action) return null;
  const isMultiattack = hasStructuredMultiattack(action);
  const actions = isMultiattack
    ? expandMultiattack(enemy?.actions, action).map((entry) => entry.action)
    : [action];
  if (!actions.length) return null;
  return {
    status: 'selecting-target', sourceCombatantId,
    attackId: `${sourceCombatantId}:${action.name || 'action'}`,
    attacker: enemy, action, actions, isMultiattack,
  };
};

export const executeTargetedActions = async ({ pending, targetId, targetExists, attackerExists, resolveAction }) => {
  if (pending?.status !== 'selecting-target' || !targetId || targetId === pending.sourceCombatantId) return [];
  if (!attackerExists(pending.sourceCombatantId) || !targetExists(targetId)) return [];
  const results = [];
  for (let index = 0; index < pending.actions.length; index += 1) {
    if (!attackerExists(pending.sourceCombatantId) || !targetExists(targetId)) break;
    results.push(await resolveAction(pending.actions[index], targetId, index));
  }
  return results;
};
